import { render, staticRenderFns } from "./LoginAndRegist.vue?vue&type=template&id=2da4c1ea&scoped=true&"
import script from "./LoginAndRegist.vue?vue&type=script&lang=js&"
export * from "./LoginAndRegist.vue?vue&type=script&lang=js&"
import style0 from "./LoginAndRegist.vue?vue&type=style&index=0&id=2da4c1ea&lang=less&scoped=true&"
import style1 from "./LoginAndRegist.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4c1ea",
  null
  
)

export default component.exports